<template>
    <div class="chart" :style="{ height: height, width: width }" />
  </template>
  
  <script>
  //import { echarts } from "echarts";
  import moment from 'moment'
  import * as echarts from "echarts";
  require("echarts/theme/shine"); // echarts theme
  export default {
    props: ["production", "consumption"],
    data() {
      return {
        chart: null,
        sidebarElm: null,
        height: "650px",
        width: "100%",
        autoResize: true,
        meters: this.$props.meter,
        months: {
          1: "Jan",
          2: "Feb",
          3: "Mar",
          4: "Apr",
          5: "May",
          6: "Jun",
          7: "Jul",
          8: "Aug",
          9: "Sep",
          10: "Oct",
          11: "Nov",
          12: "Dec",
        },
  
        dateArray: []
      };
    },
    mounted() {
      this.setDateArray();
      
      this.initChart();
      if (this.autoResize) {
        this.__resizeHandler = this.debounce(() => {
          if (this.chart) {
            this.chart.resize();
          }
        }, 100);
        window.addEventListener("resize", this.__resizeHandler);
      }
    },
    beforeDestroy() {
      if (!this.chart) {
        return;
      }
      if (this.autoResize) {
        window.removeEventListener("resize", this.__resizeHandler);
      }
      this.sidebarElm &&
        this.sidebarElm.removeEventListener(
          "transitionend",
          this.sidebarResizeHandler
        );
      this.chart.dispose();
      this.chart = null;
    },
    methods: {
  
      setDateArray () {
        const month = ["JAN","FEB","MAR","APR","MAY","JUN","JUL","AUG","SEP","OCT","NOV","DEC"];
        var pastDate = new Date();
        console.log("pastDate is: " +pastDate)
  
        for (var j = 0; j < 7; j++) {
          var tempDate = new Date(pastDate);
  
          var dd = String(tempDate.getDate()).padStart(2, '0');
          var MMM = month[tempDate.getMonth()]
          tempDate = MMM + ' ' + dd
          console.log("tempDate is: " +tempDate)
          
          this.dateArray.push(tempDate);
          pastDate.setDate(pastDate.getDate() - 5);
        }
  
        this.dateArray.reverse();
        console.log("Array of date from: " + this.dateArray[0] +" to: " + this.dateArray[6])
      },
  
      sidebarResizeHandler(e) {
        if (e.propertyName === "width") {
          this.__resizeHandler();
        }
      },
      setOptions() {
        this.chart.setOption({
          animationDuration: 5000,
          smooth: true,
          legend: {},
          xAxis: {
            type: "category",
            //data: ["17 Jan", "22 Jan", "27 Jan", "1 Feb", "6 Feb", "11 Feb", "16 Feb"],
            data: this.consumption.map(a => moment(a.time).format("DD-MM: HH:mm")),
          },
          yAxis: {
            type: "value",
          },
          series: [
            {
              data: this.production.map(a => a.value),
              type: "line",
              name: 'Production',
              label: {
                show: true,
                position: 'top',
                color: "black",
                fontSize: 12,
                formatter: function(d) {
                  //return d.name + ' ' + d.data;
                  return d.data;
                }
              },
              lineStyle: { color: "#000" },
              itemStyle: { color: "#000" },
              smooth: true,
            },
            {
              data: this.consumption.map(a => a.value),
              type: "line",
              name: 'Consumption',
              label: {
                show: true,
                position: 'top',
                color: "black",
                fontSize: 12,
                formatter: function(d) {
                  //return d.name + ' ' + d.data;
                  return d.data;
                }
              },
              lineStyle: { color: "green" },
              itemStyle: { color: "green" },
              smooth: true,
            },
            ,
            // {
            //   data: this.consumption.map(a => a.value),
            //   type: "line",
            //   name: 'Request/offer',
            //   label: {
            //     show: true,
            //     position: 'top',
            //     color: "black",
            //     fontSize: 12,
            //     formatter: function(d) {
            //       //return d.name + ' ' + d.data;
            //       return d.data;
            //     }
            //   },
            //   lineStyle: { color: "blue" },
            //   itemStyle: { color: "blue" },
            //   smooth: true,
            // },
          ],
        });
      },
      initChart() {
        this.chart = echarts.init(this.$el, "shine");
        this.setOptions();
      },
      debounce(func, wait, immediate) {
        let timeout, args, context, timestamp, result;
        const later = function () {
          // According to the last trigger interval
          const last = new Date().getTime() - timestamp;
          // The last time the wrapped function was called, the interval is last less than the set time interval wait
          if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last);
          } else {
            timeout = null;
            // If it is set to immediate===true, since the start boundary has already been called, there is no need to call it here.
            if (!immediate) {
              result = func.apply(context, args);
              if (!timeout) {
                context = args = null;
              }
            }
          }
        };
        return function (...args) {
          context = this;
          timestamp = new Date().getTime();
          const callNow = immediate && !timeout;
          // If the delay does not exist, reset the delay
          if (!timeout) {
            timeout = setTimeout(later, wait);
          }
          if (callNow) {
            result = func.apply(context, args);
            context = args = null;
          }
          return result;
        };
      },
    },
  };
  </script>